
import { defineComponent, PropType } from 'vue'
import FirstPdfPage from '@/pages/PeriodontalPage/components/pdf/FirstPdfPage.vue'
import SecondPdfPage from '@/pages/PeriodontalPage/components/pdf/SecondPdfPage.vue'
import {
  CommentType,
  ConsolidatedDataType,
  ConsolidatedTableType,
  PeriodontalDetailType,
  PeriodontalReportType,
} from '@/shared/types'

export default defineComponent({
  name: 'PeriodontalPdf',
  components: { FirstPdfPage, SecondPdfPage },

  props: {
    reportInfo: Object as PropType<PeriodontalDetailType>,
    data: Object as PropType<PeriodontalReportType>,
    plaque: Number,
    bleeding: Number,
    suppuration: Number,
    pockets: Number,
    pocketsTable: Array as PropType<ConsolidatedTableType[]>,
    comments: Array as PropType<CommentType[]>,
    consolidatedData: Object as PropType<ConsolidatedDataType>,
  },
})
